/** Formatting + date-range helpers for the Billing page. */

/** @param {number|string|null|undefined} n @returns {string} e.g. "$1,234.50" */
export function money(n) {
  const v = Number(n);
  return `$${(Number.isFinite(v) ? v : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** @param {{brand?: string, last4?: string}} c @returns {string} e.g. "American Express ending in 2004" */
export function cardLabel(c) {
  const names = { amex: 'American Express', visa: 'Visa', mastercard: 'Mastercard', discover: 'Discover', diners: 'Diners Club', jcb: 'JCB', unionpay: 'UnionPay' };
  return `${names[c?.brand] || 'Card'} ending in ${c?.last4 || '••••'}`;
}

/** @param {{expMonth?: number, expYear?: number}} c @returns {string} "11/2029" */
export function cardExpiry(c) {
  return c?.expMonth && c?.expYear ? `${String(c.expMonth).padStart(2, '0')}/${c.expYear}` : '—';
}

/**
 * Date window for the history presets, in the viewer's local time.
 * `day` = today, `week` = Sunday→Saturday of this week, `month` = this calendar month.
 * @param {'day'|'week'|'month'} kind
 * @param {Date} [now]
 * @returns {{from: Date, to: Date}}
 */
export function presetRange(kind, now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let from = start;
  let to = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
  if (kind === 'week') {
    from = new Date(start.getFullYear(), start.getMonth(), start.getDate() - start.getDay());
    to = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 7);
  } else if (kind === 'month') {
    from = new Date(start.getFullYear(), start.getMonth(), 1);
    to = new Date(start.getFullYear(), start.getMonth() + 1, 1);
  }
  return { from, to: new Date(to.getTime() - 1) };
}

/** "11/1/26 - 11/7/26" label for a range. */
export function rangeLabel({ from, to }) {
  const f = (d) => `${d.getMonth() + 1}/${d.getDate()}/${String(d.getFullYear()).slice(2)}`;
  return `${f(from)} - ${f(to)}`;
}

/** Local `YYYY-MM-DD` string → start/end-of-day Date. @returns {Date|null} */
export function parseLocalDate(str, endOfDay = false) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str || '');
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return endOfDay ? new Date(d.getTime() + 86_400_000 - 1) : d;
}
